import * as React from "react"
import { graphql } from "gatsby";
import Layout from "../components/Layout"
import { SmallBar } from "../components/PageEnd/PageEnd"
import MainPageHeader from "../components/MainPageHeader/MainPageHeader"
import OfficeLocations from "../components/OfficeLocations/OfficeLocations";
import {EmailForm} from "../components/EmailForm/EmailForm";
import MetaHead from "../components/MetaHead";

const LocationsPage = ({data}) => {
  return (
      <Layout>
        <MainPageHeader 
          title={<><span className="font-extralight">Our</span> Locations</>} 
          image={data.page.HeroImage.url} 
          gatsbyImage={data?.page?.HeroImage?.localFile?.childImageSharp?.gatsbyImageData}
          accentColour={data.page.AccentColour}
        />
        <OfficeLocations 
          title={data.page.IntroTitle}
          introText={data.page.IntroText.data.IntroText}
          introImage={data.page.IntroImage.url}
          introGatsbyImage={data?.page?.IntroImage?.localFile?.childImageSharp?.gatsbyImageData}
          accentColour={data.page.AccentColour}
          ctaLabel={data.page.CTALabel}
          ctaLink={data.page.CTALink}
          noTint={true}
        /> 
        <EmailForm location={'locations'} title={'Contact Us'} introText={'Want to know more about a Data School near you? Get in touch!'} />
        <SmallBar />
      </Layout>
  )
}

export default LocationsPage

export const Head = ({data}) => <MetaHead 
                                  title={'The Data School - Locations'}
                                  description={"Discover endless opportunities to kickstart your data career with our offices in the UK, USA, Germany, and Australia. Learn where you are and excel in the world of data!"}
                                  image={data?.page?.IntroImage?.url}
                                />

export const query = graphql`
  query ContactUsQuery {
  page: strapiDsWwwPage(slug: {eq: "locations"}) {
    Title
    IntroTitle
    AccentColour
    HeroImage {
      url
      localFile {
        childImageSharp {
          gatsbyImageData(height: 480, formats: WEBP, placeholder: BLURRED)
        }
      }
    }
    IntroImage {
      url
      localFile {
        childImageSharp {
          gatsbyImageData(height: 360, formats: WEBP, placeholder: BLURRED)
        }
      }
    }
    IntroText {
      data {
        IntroText
      }
    }
    CTALabel
    CTALink
  }
}
`
